import { MobileNavigationContext } from "context-for/mobile-navigation/mobile-navigation.context";
import { FunctionComponent, memo, useContext } from "react";
import { NavLink } from "react-router-dom";

import NavigationGroupHeader from "../navigation-group-header";
import "./mobile-navigation-link.scss";
import { IProps } from "./mobile-navigation-link.types";

/**
 * A link in the mobile navigation menu.
 * @param props.icon  The icon to display.
 * @param props.label The label to display.
 * @param props.page  The page to navigate to.
 */
const MobileNavigationLink: FunctionComponent<IProps> = ({ icon, label, page }) => {
    const { closeMenu } = useContext(MobileNavigationContext);

    return (
        <div className="mobile-navigation-link" onClick={closeMenu}>
            <NavLink to={page}>
                {({ isActive }) => <NavigationGroupHeader icon={icon} title={label} isActive={isActive} />}
            </NavLink>
        </div>
    );
};

export default memo(MobileNavigationLink);
